import { map } from './map/map';
import { addMapMouseLeaveListerner } from './map/tooltip';

export function app() {
	addMapMouseLeaveListerner();
	map();
}
